(ns client-portal.client.voice-insights.duration.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.voice-insights.duration.data :as duration.d]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [clojure.string :as s]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.recharts-components :as recharts.c]
            [shared.core.components.recharts.util :as recharts.util]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [client-portal.client.voice-insights.charts.views :as vi.charts]
            [shared.core.style :as style]
            [shared.core.router :as router]
            [shared.core.reactive :as re]
            [shared.core.time :as time]
            [shared.core.util :as util]))

(defn build-name->time-value-from-records [data]
  (some->> data
           (mapv (fn [{:keys [name values]}]
                   [name (-> values (first) :record :time-value)]))
           (into {})))

(defn build-name->time-value-from-data [k data]
  (->> data
       (map (fn [r]
              [(get r k) (:time-value r)]))
       (into {})))

(defn sankey-duration-card [{:keys [title description time-period-form-name data-key duration-filter-on-double-click?]}]
  (let [sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        grouping-form-path duration.d/settings-path
        selected-time-period @(re/subscribe [:form/val- grouping-form-path time-period-form-name])
        selected-time-period (or selected-time-period "all")
        all-charts-data @(re/subscribe [:vi-duration/charts-data-])
        all-data (some-> (util/when-not-loading all-charts-data) data-key)
        summary-data (:summary all-data)
        summary-avg (some->> summary-data
                             :avg-duration
                             (js/Math.round)
                             (time/seconds->format))
        summary-approx-median (some->> summary-data
                                       :median-duration
                                       (js/Math.round)
                                       (time/seconds->format))
        source-key (case selected-time-period
                     "hourly" :hour
                     "daily" :day
                     "day-of-week" :day-of-week
                     "all" :total
                     :hour)
        grouping-keyword (keyword selected-time-period)
        chart-data (some->> (get all-data grouping-keyword)
                            :data
                            (hash-map :source-key source-key
                                      :source-colors recharts.util/color-from-string
                                      :target-key :duration-range
                                      :target-config {}
                                      :value-key :count
                                      :sort-targets (fn [a b]
                                                      (compare (:sort-order a) (:sort-order b)))
                                      :data)
                            (recharts.util/build-sankey-data))
        data? (or (util/loading? all-charts-data)
                  (and (not-empty (:nodes chart-data)) (not-empty (:links chart-data))))
        daily? (= selected-time-period "daily")
        daily-day->time-value (when (and data? daily?)
                                (build-name->time-value-from-data :day
                                                                  (-> (get all-data grouping-keyword) :data)))]
    (when all-data
      [alc/card {:title title
                 :subtitle description
                 :material-icon-type :schedule}
       (when data?
         [:div {:style {:display :flex
                        :align-items :center
                        :gap 12}}
          [alc/pill-button-group {:selected-value selected-time-period
                                  :form-path grouping-form-path
                                  :form-name time-period-form-name
                                  :options [{:label "Total" :value "all"}
                                            {:label "Day of Week" :value "day-of-week"}
                                            {:label "Daily" :value "daily"}
                                            {:label "Hourly" :value "hourly"}]}]])
       (if data?
         [recharts.c/sankey-chart
          {:nodes (:nodes chart-data)
           :links (:links chart-data)
           :link-config (when duration-filter-on-double-click?
                          {:on-double-click
                           (fn [e {:keys [payload]}]
                             (let [source-name (-> payload :source :name)
                                   target-name (-> payload :target :name)
                                   duration-filter (when target-name
                                                     (let [[first-half second-half] (s/split (s/trim target-name) " ")
                                                           unit (when (s/ends-with? second-half "s")
                                                                  (subs second-half 0 (dec (count second-half))))
                                                           start (if (s/ends-with? first-half "+")
                                                                   (some-> first-half
                                                                           (s/split "+")
                                                                           (first)
                                                                           (s/trim)
                                                                           (util/parse-int))
                                                                   (some-> first-half
                                                                           (s/split "-")
                                                                           (first)
                                                                           (s/trim)
                                                                           (util/parse-int)))
                                                           end (when-not (s/ends-with? first-half "+")
                                                                 (some-> first-half
                                                                         (s/split "-")
                                                                         (last)
                                                                         (s/trim)
                                                                         (util/parse-int)))]
                                                       {:unit unit
                                                        :start start
                                                        :end end}))
                                   fd (->> [(condp = selected-time-period
                                              "hourly"
                                              (let [hour (-> source-name
                                                             (s/lower-case)
                                                             (s/replace " " ""))]
                                                {:by "time-of-day"
                                                 :condition "include"
                                                 :join "or"
                                                 :value [{:name hour
                                                          :value (util/time-of-day-with-leading-zero
                                                                   hour)}]})

                                              "day-of-week"
                                              {:by "day-of-week"
                                               :condition "include"
                                               :join "or"
                                               :value [{:name source-name
                                                        :value source-name}]}

                                              nil)
                                            {:by "duration"
                                             :condition "include"
                                             :join "or"
                                             :value [{:name target-name
                                                      :value duration-filter}]}]
                                           (filterv identity)
                                           (sessions.d/filters->query-param))]
                               (when (and (:start duration-filter) (:unit duration-filter))
                                 (router/open-route-based-on-event
                                   e
                                   [:vi/sessions nil (cond-> (assoc sessions-query-params
                                                               :fd fd)
                                                             (= selected-time-period "daily")
                                                             (assoc :tf -1
                                                                    :start (get daily-day->time-value source-name)
                                                                    :end (get daily-day->time-value source-name)))]))))})
           :tooltip-config {:sort-by-value? true
                            :limit 20
                            :show-double-click-message? duration-filter-on-double-click?}
           :height (recharts.util/sankey-chart-height chart-data)
           :node-padding 20
           :margin {:left 140 :right 240 :top 20 :bottom 20}}]
         [empty-state/no-chart-data {}])
       (when (or (not-empty summary-avg) (not-empty summary-approx-median))
         (let [metric-style {:color (style/alc-color "Text/secondary")
                             :font-size 12
                             :font-weight 600
                             :line-height 1.3
                             :flex "0 0 auto"
                             :display :flex
                             :align-items :center
                             :justify-content :center}]
           [:div {:style {:display :flex
                          :align-items :center
                          :justify-content :center
                          :gap 16
                          :padding-bottom 10
                          :width "100%"}}
            (when (not-empty summary-avg)
              [:div {:style metric-style}
               (str "Average: " summary-avg)])
            (when (and (not-empty summary-avg) (not-empty summary-approx-median))
              [:div {:style {:background-color (style/alc-color "Text/secondary")
                             :opacity 0.2
                             :height 22
                             :width 1}}])
            (when (not-empty summary-approx-median)
              [:div {:style metric-style}
               (str "Median: " summary-approx-median)])]))])))

(defn call-duration-card []
  [sankey-duration-card {:title "Session Duration"
                         :description "Duration of entire ordering session based on customer's car presence at speaker post"
                         :time-period-form-name :call-duration-time-period-value
                         :data-key :call-duration-range-by-time
                         :duration-filter-on-double-click? true}])

(defn phase-intro-card []
  [sankey-duration-card {:title "Idle Time Between Greeting and Ordering"
                         :description "Elapsed duration between crew greeting and start of customer ordering"
                         :time-period-form-name :phase-intro-duration-time-period-value
                         :data-key :phase-intro-duration-range-by-time}])

(defn phase-ordering-card []
  [sankey-duration-card {:title "Ordering Phase"
                         :description "Full duration of all utterances as part of order taking"
                         :time-period-form-name :phase-ordering-duration-time-period-value
                         :data-key :phase-ordering-duration-range-by-time}])

(defn issue-wait-to-ordering-card []
  [sankey-duration-card {:title "Idle Time Between Crew Wait Request and Ordering"
                         :description "In sessions where the crew explicitly asks the customers to wait before ordering, measures the actual duration of the session gap"
                         :time-period-form-name :issue-wait-to-ordering-duration-time-period-value
                         :data-key :issue-wait-to-ordering-duration-range-by-time}])

(defn intent-durations-card []
  (let [grouping-form-path duration.d/settings-path
        grouping-form-name :intent-duration-grouping-value
        selected-grouping- (re/subscribe [:form/val- grouping-form-path grouping-form-name])
        base-data (some-> (util/when-not-loading @(re/subscribe [:vi-duration/charts-data-]))
                          :intent-durations-by-value)]
    (when base-data
      (let [top-10-keys (some->> base-data
                                 (group-by :value)
                                 (mapv (fn [[value vals]]
                                         {:value value
                                          :count (apply + (map :count vals))}))
                                 (sort-by :count)
                                 (reverse)
                                 (take 10)
                                 (map :value)
                                 (into #{}))
            selected-grouping (or @selected-grouping- "top-10")
            top-10? (= selected-grouping "top-10")
            data? (not-empty base-data)
            chart-data (some->> base-data
                                (#(if (and top-10? top-10-keys)
                                    (filterv (fn [r] (contains? top-10-keys (:value r))) %)
                                    %))
                                (hash-map :source-key :value
                                          :source-colors recharts.util/color-from-string
                                          :sort-sources (fn [a b]
                                                          (compare (:value a) (:value b)))
                                          :target-key :duration-range
                                          :sort-targets (fn [a b]
                                                          (compare (:sort-order a) (:sort-order b)))
                                          :target-colors recharts.util/color-from-string
                                          :value-key :count
                                          :data)
                                (recharts.util/build-sankey-data))]
        [alc/card {:title "Intent Duration"
                   :material-icon-type :schedule}
         (when (and data? (>= (count top-10-keys) 10))
           [alc/pill-button-group {:selected-value selected-grouping
                                   :form-path grouping-form-path
                                   :form-name grouping-form-name
                                   :options [{:label "Top 10" :value "top-10"}
                                             {:label "All Intents" :value "all"}]}])
         (if (not-empty base-data)
           [recharts.c/sankey-chart
            {:nodes (:nodes chart-data)
             :links (:links chart-data)
             :tooltip-config {:sort-by-value? true
                              :limit 20
                              :show-double-click-message? false}
             :height (recharts.util/sankey-chart-height chart-data)
             :node-padding 20
             :margin {:left 340 :right 140 :top 20 :bottom 20}}]
           [empty-state/no-chart-data {}])]))))

(defn issue-wait-card []
  (let [by-count-sessions* (re/ratom "count")
        sessions-query-params- (re/subscribe [:sessions/relevant-query-params-])
        grouping-form-path duration.d/settings-path
        time-period-form-name :issue-wait-time-period-value
        selected-time-period- (re/subscribe [:form/val- grouping-form-path time-period-form-name])
        all-charts-data- (re/subscribe [:vi-duration/charts-data-])
        core-by-time-counts- (re/subscribe [:voice-insights/core-session-by-time-counts-keyed-])
        crew-name- (re/subscribe [:voice-insights/crew-name-])]
    (fn []
      (let [by-count? (= @by-count-sessions* "count")
            by-sessions? (= @by-count-sessions* "sessions")
            sessions-query-params @sessions-query-params-
            selected-time-period @selected-time-period-
            selected-time-period (or selected-time-period "all")
            all-charts-data @all-charts-data-
            core-by-time-counts @core-by-time-counts-
            all-data (when-not (util/loading? core-by-time-counts)
                       (some-> (util/when-not-loading all-charts-data)
                               :issue-wait-by-time))
            time-period-key (case selected-time-period
                              "hourly" :hour
                              "daily" :day
                              "day-of-week" :day-of-week
                              :hour)
            grouping-keyword (keyword selected-time-period)
            value-key (if by-sessions? "Percent of Sessions" "Total")
            chart-data (some->> (get all-data grouping-keyword)
                                :data
                                (mapv (fn [r]
                                        {:name (if (= selected-time-period "all")
                                                 "Total"
                                                 (get r time-period-key))
                                         :values [{:key value-key
                                                   :value (if by-sessions?
                                                            (if (pos? (:count r))
                                                              (-> (:count r)
                                                                  (/ (max (-> (get core-by-time-counts
                                                                                   (:time-grouping r))
                                                                              (get (:time-value r))
                                                                              :count)
                                                                          (:count r)))
                                                                  (* 100)
                                                                  (util/to-precision-num :precision 1))
                                                              0)
                                                            (:count r))
                                                   :record r}]})))
            chart-keys-config {value-key {:fill "#B2C4FC"}}
            data? (or (util/loading? all-charts-data)
                      (if (= selected-time-period "all")
                        (some-> chart-data (first) :values (first) :record :count (not= 0))
                        (not-empty chart-data)))
            daily? (= selected-time-period "daily")
            daily-day->time-value (when (and data? daily?) (build-name->time-value-from-records chart-data))]
        (when all-data
          [alc/card {:title (str @crew-name- " Wait Requests")
                     :subtitle (str "Count of sessions where the "
                                    (s/lower-case @crew-name-)
                                    " explicitly asks the customers to wait before ordering")
                     :icon-type :TimeWaitIcon}
           [:div {:style {:display :flex
                          :flex-direction :row
                          :align-items :flex-start
                          :justify-content :space-between}}
            (when data?
              [alc/pill-button-group {:selected-value selected-time-period
                                      :form-path grouping-form-path
                                      :form-name time-period-form-name
                                      :options [{:label "Total" :value "all"}
                                                {:label "Day of Week" :value "day-of-week"}
                                                {:label "Daily" :value "daily"}
                                                {:label "Hourly" :value "hourly"}]}])
            (when (and data? (not-empty core-by-time-counts))
              [alc/up-toggle-group {:type "single"
                                    :value @by-count-sessions*
                                    :on-value-change #(reset! by-count-sessions* (if by-count? "sessions" "count"))
                                    :items [{:value "count" :content "By Total"}
                                            {:value "sessions" :content "By Sessions"}]}])]
           (if data?
             [recharts.c/bar-chart
              {:data chart-data
               :data-keys-config chart-keys-config
               :legend? false
               :margin {:top 20 :right 0 :left 0 :bottom -50}
               :bar-config {:on-double-click (fn [click-data _ e]
                                               (let [payload-name (-> click-data :payload :name)
                                                     fd (->> [(condp = selected-time-period
                                                                "hourly"
                                                                (let [hour (-> payload-name
                                                                               (s/lower-case)
                                                                               (s/replace " " ""))]
                                                                  {:by "time-of-day"
                                                                   :condition "include"
                                                                   :join "or"
                                                                   :value [{:name hour
                                                                            :value (util/time-of-day-with-leading-zero
                                                                                     hour)}]})

                                                                "day-of-week"
                                                                {:by "day-of-week"
                                                                 :condition "include"
                                                                 :join "or"
                                                                 :value [{:name payload-name
                                                                          :value payload-name}]}

                                                                nil)
                                                              {:by "tags"
                                                               :condition "include"
                                                               :join "or"
                                                               :value [{:name "issue"
                                                                        :value "wait"}]}]
                                                             (filterv identity)
                                                             (sessions.d/filters->query-param))]
                                                 (router/open-route-based-on-event
                                                   e
                                                   [:vi/sessions nil (cond-> (assoc sessions-query-params
                                                                               :svm "utterances"
                                                                               :fd fd)
                                                                             (= selected-time-period "daily")
                                                                             (assoc :tf -1
                                                                                    :start (get daily-day->time-value payload-name)
                                                                                    :end (get daily-day->time-value payload-name)))])))}
               :chart-height 500
               :x-axis-config {:angle -45
                               :height 150}
               :tooltip-config {:header-transf-name-fn identity
                                :label-transf-fn identity
                                :value-transf-fn (when by-sessions? #(str %1 "%"))
                                :show-percent? false
                                :show-double-click-message? true
                                :style-map {:max-width 240}}}]
             [empty-state/no-chart-data {}])])))))

(defn root [_]
  (let [tags- (re/subscribe [:vi-tags/list-by-current-concept-id-])
        all-charts-data- (re/subscribe [:vi-duration/charts-data-])
        core-by-time-data- (re/subscribe [:voice-insights/core-session-by-time-counts-])
        chart-ids-loading?- (re/subscribe [:voice-insights/charts-loading?- ["hold-counts-by-time-period"
                                                                             "transfer-vs-other-holds-by-time-period"
                                                                             "avg-silence-per-call-by-time-period"
                                                                             "transfer-outcomes-by-time-period"
                                                                             "transfer-starts-by-child"]])]
    (re/create-class
      {:component-did-mount #(re/dispatch [:vi-duration/initialize])
       :reagent-render
       (fn [args]
         @chart-ids-loading?-
         [l/logged-in-with-header-nav-vi
          args
          [:div {:style {:display :flex
                         :flex-direction :column
                         :width "100%"
                         :min-height "100%"}}
           (cond
             (or (util/loading? @tags-)
                 (util/loading? @all-charts-data-)
                 (util/loading? @core-by-time-data-)
                 @chart-ids-loading?-)
             [empty-state/loading-charts-card]

             :else
             [:div {:style {:display :flex
                            :flex-direction :column
                            :gap 12
                            :padding "20px 17px 29px"}}
              [call-duration-card]
              [phase-intro-card]
              [phase-ordering-card]
              [issue-wait-to-ordering-card]
              [intent-durations-card]
              [issue-wait-card]
              [vi.charts/chart-card {:chart-id "hold-counts-by-time-period"
                                     :chart-type "BarChart"
                                     :title "Hold Counts"
                                     :name-key "time_value"
                                     :data-keys ["count"]
                                     :filter-tags {:by "tags"
                                                   :condition "include"
                                                   :join "or"
                                                   :value [{:name "hold" :value "start"}]}
                                     :required-tag-names ["call-summary-counts"]
                                     :show-time-period-toggle? true
                                     :include-session-double-click? true
                                     :add-listener-dispatch? true
                                     :config-overrides {:tooltip-config {:label-transf-fn (fn [_] "Count")
                                                                         :show-percent? false}
                                                        :margin {:top 20 :right 30 :left 20 :bottom 0}
                                                        :legend? false}}]
              [vi.charts/chart-card {:chart-id "transfer-vs-other-holds-by-time-period"
                                     :chart-type "BarChart"
                                     :title "Hold Events"
                                     :stack-id "holds"
                                     :name-key "time_value"
                                     :data-keys ["transfer-holds" "other-holds"]
                                     :filter-tags {:by "tags"
                                                   :condition "include"
                                                   :join "or"
                                                   :value [{:name "hold" :value "start"}
                                                           {:name "transfer" :value "start"}]}
                                     :required-tag-names ["call-summary-counts"]
                                     :show-time-period-toggle? true
                                     :include-session-double-click? true
                                     :add-listener-dispatch? true
                                     :config-overrides {:tooltip-config {:label-transf-fn util/->capitalize-words
                                                                         :show-percent? true}
                                                        :legend-config {:display-fn util/->capitalize-words}
                                                        :margin {:top 20 :right 30 :left 20 :bottom 0}
                                                        :legend? true}}]
              [vi.charts/chart-card {:chart-id "avg-silence-per-call-by-time-period"
                                     :chart-type "BarChart"
                                     :title "Average Silence Per Call"
                                     :stack-id "time"
                                     :name-key "time_value"
                                     :data-keys ["silence-time-above-threshold" "other-silence-time"]
                                     :required-tag-names ["call-summary-counts"]
                                     :show-time-period-toggle? true
                                     :add-listener-dispatch? true
                                     :config-overrides {:tooltip-config {:label-transf-fn util/->capitalize-words
                                                                         :value-transf-fn #(str % "s")
                                                                         :show-percent? true}
                                                        :legend-config {:display-fn util/->capitalize-words}
                                                        :margin {:top 20 :right 30 :left 20 :bottom 0}
                                                        :legend? true}}]
              [vi.charts/chart-card {:chart-id "transfer-outcomes-by-time-period"
                                     :chart-type "BarChart"
                                     :title "Transfers"
                                     :stack-id "time"
                                     :name-key "time_value"
                                     :data-keys ["completed-transfers" "incomplete-transfers"]
                                     :filter-tags {:by "tags"
                                                   :condition "include"
                                                   :join "or"
                                                   :value [{:name "transfer" :value "start"}]}
                                     :required-tag-names ["call-summary-counts"]
                                     :show-time-period-toggle? true
                                     :include-session-double-click? true
                                     :add-listener-dispatch? true
                                     :config-overrides {:tooltip-config {:label-transf-fn util/->capitalize-words
                                                                         :show-percent? true}
                                                        :legend-config {:display-fn util/->capitalize-words}
                                                        :margin {:top 20 :right 30 :left 20 :bottom 0}
                                                        :legend? true}}]
              [vi.charts/chart-card {:chart-id "transfer-starts-by-child"
                                     :chart-type "PieChart"
                                     :title "Human Agent Transfer Queue"
                                     :name-key "child_value"
                                     :data-key "count"
                                     :top-n-toggle 10
                                     :filter-tags-fn (fn [d _]
                                                       {:by "tags"
                                                        :condition "include"
                                                        :join "or"
                                                        :value [{:name "transfer" :value "start"}]
                                                        :children [{:by (get d "child_name")
                                                                    :condition "include"
                                                                    :join "or"
                                                                    :value [(get d "child_value")]}]})
                                     :required-tag-names ["transfer"]
                                     :include-session-double-click? true
                                     :add-listener-dispatch? true
                                     :config-overrides {:tooltip-config {:label-transf-fn util/->capitalize-words
                                                                         :show-percent? true}
                                                        :legend-config {:display-fn util/->capitalize-words}
                                                        :margin {:top 20 :right 30 :left 20 :bottom 20}
                                                        :legend? true}}]])]])})))
